import * as React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Card, Radio, RadioGroup } from "@mui/material";
import idioma_lbl from "./index";

export default function Objetivo({ handler_data, handler_obj }) {
  // multiple checkbox for Objetivo

  const [isCheckedArray, setIsCheckedArray] = React.useState(
    new Array(8).fill(false)
  );
  const [countChecked, setCountChecked] = React.useState(0);

  const disableCheckedArray = (idx) => {
    if (countChecked >= 2 && !isCheckedArray[idx]) {
      return true;
    } else {
      return false;
    }
  };

  const updateCheckedArray = (idx) => (e) => {
    let checkedArray = isCheckedArray;
    let count_total = countChecked;
    checkedArray[idx] = e.target.checked;
    if (e.target.checked === true) {
      count_total = count_total + 1;
    } else {
      count_total = count_total - 1;
    }
    setIsCheckedArray(checkedArray);
    setCountChecked(count_total);
  };

  return (
    <React.Fragment>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item>
          <Typography variant="h6" align="center" gutterBottom>
            {idioma_lbl === "en" ? "What skin would you like to achieve?" : "¿Qué piel quieres lograr?"}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} justifyContent="center">
        <Grid item>
          <FormGroup onChange={handler_obj}>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={disableCheckedArray(0)}
                  onChange={updateCheckedArray(0)}
                />
              }
              label={idioma_lbl === "en" ? "Hydrated and comfortable" : "Hidratada y confortable"}
              value="hidratada"
            />
            <FormControlLabel
              control={
                <Checkbox
                  disabled={disableCheckedArray(1)}
                  onChange={updateCheckedArray(1)}
                />
              }
              label={idioma_lbl === "en" ? "Bright" : "Luminosa"}
              value="luminosa"
            />
            <FormControlLabel
              control={
                <Checkbox
                  disabled={disableCheckedArray(2)}
                  onChange={updateCheckedArray(2)}
                />
              }
              label={idioma_lbl === "en" ? "Without spots and with a unified tone" : "Libre de manchas y con tono uniforme"}
              value="sinmanchas"
            />
            <FormControlLabel
              control={
                <Checkbox
                  disabled={disableCheckedArray(3)}
                  onChange={updateCheckedArray(3)}
                />
              }
              label={idioma_lbl === "en" ? "With reduced pores" : "Con poros reducidos"}
              value="sinporos"
            />
            <FormControlLabel
              control={
                <Checkbox
                  disabled={disableCheckedArray(4)}
                  onChange={updateCheckedArray(4)}
                />
              }
              label={idioma_lbl === "en" ? "Elastic, firm and without wrinkles" : "Elástica, firme y libre de arrugas"}
              value="sinarrugas"
            />
            <FormControlLabel
              control={
                <Checkbox
                  disabled={disableCheckedArray(5)}
                  onChange={updateCheckedArray(5)}
                />
              }
              label={idioma_lbl === "en" ? "Eye contour without dark circles and eyebags" : 
              "Contorno de ojos liso sin bolsas ni ojeras"}
              value="contornoojos"
            />
            <FormControlLabel
              control={
                <Checkbox
                  disabled={disableCheckedArray(6)}
                  onChange={updateCheckedArray(6)}
                />
              }
              label={idioma_lbl === "en" ? "Without pimples and black heads" : "Libre de granos y espinillas"}
              value="singranos"
            />
            <FormControlLabel
              control={
                <Checkbox
                  disabled={disableCheckedArray(7)}
                  onChange={updateCheckedArray(7)}
                />
              }
              label={idioma_lbl === "en" ? "Smooth and without imperfections" : "Lisa y libre de imperfecciones o marcas"}
              value="sinmarcas"
            />
          </FormGroup>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
